// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Box, CircularProgress } from "@mui/material";

export default function ProtectedRoute({ children }) {
  const { session, loading } = useAuth();

  // If we are still talking to Supabase, show the spinner
  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }
  // If no session exists after loading is done, send to login
  if (!session) {
    return <Navigate to="/login" replace />;
  }

  // If logged in, show the protected content
  return children;
}
